import React from "react";
import { INK } from "../styles";
import type { SectionProps } from "../types";

export default function Section({ id, title, children }: SectionProps) {
  return (
    <div id={id} style={{ marginBottom: 36 }}>
      <h2
        style={{
          margin: "0 0 14px 0",
          fontSize: 22,
          fontWeight: 700,
          color: INK,
          letterSpacing: "-0.005em",
        }}
      >
        {title}
      </h2>
      <div style={{ fontSize: 15, lineHeight: 1.65, color: INK }}>
        {children}
      </div>
    </div>
  );
}